import { customElement, WebComponent } from '@/lib/components'

import styles from './DialogFooter.styles.css'

@customElement('solid-ui-dialog-footer')
export default class DialogFooter extends WebComponent {
  static styles = styles
}
